import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import isPositiveValidator from './is-positive.directive';
import controller from './relative-risk-details.controller';
import directive from './relative-risk-details.directive';
import maximumAllowableDowntimeMessagesTpl from '../../messages/maximum-allowable-downtime.messages.html';
import recoveryTimeObjectiveMessagesTpl from '../../messages/recovery-time-objective.messages.html';


export default angular.module('app.components.advisory.bcp.relativeRiskDetails', [
  alerts,
  constants,
])
  .directive('isPositive', isPositiveValidator)
  .directive('bcpRelativeRiskDetails', directive)
  .controller('RelativeRiskDetailsController', controller)
  .run(($templateCache) => {
    $templateCache.put('maximum-allowable-downtime.messages.html', maximumAllowableDowntimeMessagesTpl);
    $templateCache.put('recovery-time-objective.messages.html', recoveryTimeObjectiveMessagesTpl);
  })
  .name;

console.log('app.components.advisory.bcp.relativeRiskDetails created');
